// extracted by mini-css-extract-plugin
export default {"l_HistoryBackIcon_main":"HistoryBackIcon_l_HistoryBackIcon_main__hX6ZB","l_HistoryBackIcon_iconImg":"HistoryBackIcon_l_HistoryBackIcon_iconImg__-+pUY"};